import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'content-loading',
  templateUrl: './content-loading.component.html',
  styleUrls: ['./content-loading.component.scss']
})
export class ContentLoadingComponent implements OnInit {

  @Input() width: any;
  widthList: any = {};
  constructor() {
    
  }

  ngOnInit() {
    this.widthList[this.width] = true;
  }

}
